<template>
    <Sortable
        :list="items"
        item-key="_id"
        tag="div"
        :group="field.group ?? null"
        class="forms__field--repeater__sortable"
        @end="(e) => emit('sort-end', e)"
        @add="(e, item) => emit('sort-add', e, item)"
    >
        <template #empty>
            <div class="forms__field--repeater__empty-wrapper">
                <div class="forms__field--repeater__empty-inside">
                    <span>{{ lang('fields::fields.repeater.empty') }}</span>
                </div>
            </div>
        </template>
        <template #item="{ element, index }">
            <div
                :key="`${element._id}-${index}`"
                class="forms__field--repeater-row__item"
            >
                <div class="forms__field--repeater-row__item__drag cursor-grab">
                    <icon icon="hero/solid/ellipsis-vertical" class="w-3 h-3"></icon>
                </div>
                <div class="forms__field--repeater-row__item__fields">
                    <template v-for="subfield in field.fields" :key="subfield.slug">
                        <div
                            v-if="!subfield.condition ? true : solveCondition(subfield.condition, element)"
                            class="forms__field--repeater-row__item__field"
                        >
                            <Field
                                :id="`${field.slug ?? ''}${subfield.slug}-${element._id ?? index}`"
                                v-model="element[subfield.slug]"
                                :field="subfield"
                                :file="subfield.type === 'file' ? element[subfield.slug] : null"
                                :dusk="`form-${subfield.slug}`"
                                :tabindex="tabindex"
                                :options="subfield.options ? subfield.options : null"
                                :multiple="numberToBoolean(multiple)"
                                label-position="top"
                                :searchable="numberToBoolean(subfield.searchable)"
                                size="sm"
                                :repeater-element="element"
                            />
                        </div>
                    </template>
                </div>
                <div class="forms__field--repeater-row__item__actions">
                    <Button type="button" size="sm" @click="emit('remove', index)">
                        <icon
                            :icon="minusIcon ?? 'hero/solid/minus-sm'"
                            class="w-5 h-5"
                        ></icon>
                    </Button>
                </div>
            </div>
        </template>
    </Sortable>
</template>

<script lang="ts" setup>
import { solveCondition } from '@src/Fields/Pages/conditions';
import Sortable from '@src/Common/Components/Sortable.vue';

defineProps<{
    field: any;
    items: any[];
    tabindex?: number | string | null;
    multiple?: boolean;
    inline?: boolean;
    size?: string;
    labelPosition?: string;
    minusIcon?: string;
}>();

const emit = defineEmits<{
    (event: 'remove', index: number): void;
    (event: 'sort-end', e: any): void;
    (event: 'sort-add', e: any, item: any): void;
}>();

 const numberToBoolean = (input: number | boolean | string | undefined) => {
    if (typeof input === 'undefined') {
        return false;
    }
    if (typeof input === 'boolean') {
        return input;
    }
    if (typeof input === 'string') {
        return input === '1';
    }
    return input === 1;
};
</script>
